export const SUPPORTED_WALLET_CHAINS = ['solana', 'ethereum', 'base', 'monad', 'aptos'];

export const normalizeWalletChain = (chain) => {
    const normalized = (chain || '').toString().trim().toLowerCase();
    return SUPPORTED_WALLET_CHAINS.includes(normalized) ? normalized : '';
};

export const inferWalletChainFromAddress = (address) => {
    const value = (address || '').toString().trim();
    if (!value) {
        return '';
    }

    if (/^0x[a-fA-F0-9]{64}$/.test(value)) {
        return 'aptos';
    }

    if (/^0x[a-fA-F0-9]{40}$/.test(value)) {
        return 'ethereum';
    }

    return 'solana';
};

export const getLinkedWalletChainFromUserData = (userData) => {
    const explicitChain = normalizeWalletChain(
        userData?.linked_wallet_chain ||
        userData?.linked_wallet_network ||
        userData?.wallet_chain
    );

    if (explicitChain) {
        return explicitChain;
    }

    return inferWalletChainFromAddress(userData?.linked_wallet_address);
};
